import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../lib/preact-pure-component'
import classNames from 'classnames'

interface Props {
  text: string
  chapter: number
  totalChapters: number
}

export class Chapter extends PureComponent<Props, {}> {
  render() {
    const dots = [...Array(this.props.totalChapters)].map((e, idx) => {
      const dotClass = classNames(style.dot, { [style.filledDot]: idx < this.props.chapter })
      return <span className={dotClass} />
    })
    return (
      <div className={style.wrapper}>
        <div className={style.chapterNumber}>
          {`Chapter`}
          <span className={style.green}>_</span>
          {`${this.props.chapter}`}
        </div>
        {dots}
        <h3 className={style.text}>{this.props.text}</h3>
      </div>
    )
  }
}
